import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { usePageType } from './usePageType';
import { PageType } from './usePageType/usePageType.types';
import {
  GetRelatedAdsResponse,
  RelatedAdsConnection,
} from '@/api/types/ads.types';
import { GET_RELATED_ADS } from '@/api/queries/ads.queries';
import { MAX_RELATED_ADS } from '@/views/Ads/Ad.view.constants';

export function useRelatedAds(): {
  relatedAds: RelatedAdsConnection | undefined;
  loading: boolean;
} {
  const {
    query: { slug },
  } = useRouter();
  const pageType = usePageType();

  const isBrowser = typeof window !== 'undefined';
  const legacyId = Array.isArray(slug) ? slug[2] : undefined;

  const { data, loading } = useQuery<GetRelatedAdsResponse>(GET_RELATED_ADS, {
    variables: { legacyId, first: MAX_RELATED_ADS },
    errorPolicy: 'all',
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'network-only',
    skip:
      !isBrowser ||
      !legacyId ||
      pageType === PageType.NewAd ||
      pageType !== PageType.Ad,
  });

  return { relatedAds: data?.relatedAds, loading };
}
